import React, { useState } from 'react';
import {
  makeStyles,
  Card,
  OutlinedInput,
  InputAdornment,
  Typography,
  IconButton,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Button from 'components/common/Button';
import CancelIcon from '@material-ui/icons/Cancel';

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(4),
    borderRadius: 6,
  },
  input: {
    '&:hover': {
      '& input': {
        backgroundColor: 'transparent',
      },
    },
  },
  icon: {
    color: theme.palette.text.secondary,
  },
  iconSize: {
    fontSize: 18,
  },
}));

const Search = ({ handleSearch }) => {
  const classes = useStyles();
  const [searchQuery, setSearchQuery] = useState('');

  const onKeyDown = (e) => {
    if (e.keyCode === 13) {
      handleSearch(searchQuery);
    }
  };

  return (
    <Card className={classes.card}>
      <OutlinedInput
        placeholder="Search College Name"
        classes={{
          root: classes.input,
        }}
        onChange={(e) => setSearchQuery(e.target.value)}
        onKeyDown={onKeyDown}
        value={searchQuery}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon fontSize="small" className={classes.icon} />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end">
            <IconButton size="small" onClick={() => setSearchQuery('')}>
              <CancelIcon
                fontSize="small"
                classes={{
                  fontSizeSmall: classes.iconSize,
                }}
                className={classes.icon}
              />
            </IconButton>
            <Button
              color="primary"
              size="large"
              onClick={() => handleSearch(searchQuery)}
            >
              <Typography color="primary">Search</Typography>
            </Button>
          </InputAdornment>
        }
        fullWidth
      />
    </Card>
  );
};

export default Search;
